import React, { FC, useState } from 'react'
import './drop-down-menu.css'

// COMPONENTS
import Card from '../card'
import DropDown from '../drop-down'
import { Chevron } from '@icons'


interface Props extends React.HTMLAttributes<HTMLDivElement> {
    setActiveItem?: React.SetStateAction<any>,
    setActiveItemByIndex?: (index: number) => void
    activeItem: string
    activeItemIndex?: number
    items: string[]
}

const DropDownMenu: FC<Props> = (props) => {
    const { setActiveItem, setActiveItemByIndex, activeItem, activeItemIndex, items, ...divProps } = props
    const [isOpen, setIsOpen] = useState(false)

    return (
        <DropDown className="drop-down-menu" {...divProps} state={[isOpen, setIsOpen]}>
            <div className="medium textfield">
                <div className="textfield-container">
                    <p className="content" style={{ margin: 0, whiteSpace: 'nowrap' }}>{activeItem}</p>
                    <div className="inline-element right">
                        <Chevron height='0.75rem' width='0.75rem' facing={isOpen ? "down" : "up"} />
                    </div>
                </div>
            </div>
            <Card>
                {items.map((item, index) => (
                    <p className="menu-item" style={{ background: (((activeItemIndex === undefined) && (activeItem === item)) || ((activeItemIndex !== undefined) && (activeItemIndex === index))) ? 'var(--splitcard-gray-100)' : ''}} key={`${item}-${index}`} onClick={() => {
                        setIsOpen(false)
                        if (!!setActiveItem) setActiveItem(item)
                        if (!!setActiveItemByIndex) setActiveItemByIndex(index)
                    }}>{item}</p>
                ))}
            </Card>
        </DropDown>
    )
}

export default DropDownMenu